// src/algorithms/halftone/index.ts
import type { DitherAlgorithm } from '../../core/types';

export const HALFTONE_ALGORITHMS: DitherAlgorithm[] = [
  { id: 'halftone-dot',     label: 'Halftone Dot',     kind: 'halftone', runner: 'gpu', tileRange: { min: 1, max: 16 } },
  { id: 'halftone-line',    label: 'Halftone Line',    kind: 'halftone', runner: 'gpu', tileRange: { min: 1, max: 16 } },
  { id: 'halftone-cross',   label: 'Halftone Cross',   kind: 'halftone', runner: 'gpu', tileRange: { min: 1, max: 16 } },
  { id: 'halftone-diamond', label: 'Halftone Diamond', kind: 'halftone', runner: 'gpu', tileRange: { min: 1, max: 16 } },
  { id: 'halftone-square',  label: 'Halftone Square',  kind: 'halftone', runner: 'gpu', tileRange: { min: 1, max: 16 } },
];

export const HALFTONE_SHAPE_FROM_ID: Record<string, 'dot'|'line'|'cross'|'diamond'|'square'> = {
  'halftone-dot':     'dot',
  'halftone-line':    'line',
  'halftone-cross':   'cross',
  'halftone-diamond': 'diamond',
  'halftone-square':  'square',
};
